import { render, staticRenderFns } from "./TosfHeiProfile.vue?vue&type=template&id=f440c960&scoped=true"
import script from "./TosfHeiProfile.vue?vue&type=script&lang=js"
export * from "./TosfHeiProfile.vue?vue&type=script&lang=js"
import style0 from "./TosfHeiProfile.vue?vue&type=style&index=0&id=f440c960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f440c960",
  null
  
)

export default component.exports